let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("P2OWY"), load("4tiwv"), load("4XFRu"), load("klM7C"), load("jvuhr"), load("hhss7"), load("eK94l")]).then(() => parcelRequire('8fb5x'));